<template>
  <div class="mx-10 ma-5">
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>
    <div>
      <v-card flat class="pa-5">
        <PageTitleWithSearch
          :title="'Products'"
          :btnName="'Add New Supplier'"
          :btnColor="'#00B3FF'"
          :btnRoute="'/supplier/create'"
          :btnPermission="'Suppliers.create'"
          :btnEnable="true"
          :loading="loading"
          :search="search"
          @searchText="searchChange($event)"
        />
        <DataTableWithPagination
          :headers="headers"
          :items="suppliers"
          :loading="loading"
          :page="page"
          :total="total"
          @pageChange="page = $event"
        >
          <template #row="{ item}">
            <tr>
              <td>
                <v-avatar size="36px">
                  <img v-if="item.profile_image" :src="item.profile_image" />
                  <img v-else :src="defaultImage" />
                </v-avatar>
              </td>
              <td class="text-left">
                <template v-if="hasPermission('Suppliers.view')">
                  <router-link
                    :to="'/supplier/' + item.uuid + '/info'"
                    class="router-link"
                  >
                    {{ item.supplier_code || "N/A" }}
                  </router-link>
                </template>
                <template v-else>
                  {{ item.supplier_code || "N/A" }}
                </template>
              </td>
              <td class="text-left">{{ item.name }}</td>
              <td class="text-left">
                <span
                  v-if="
                    item.address &&
                      item.address !== 'null' &&
                      item.address !== ''
                  "
                  >{{ item.address }}</span
                >
                <span v-else>-</span>
              </td>
              <td class="text-left">
                <span
                  v-if="
                    item.mobile && item.mobile !== 'null' && item.mobile !== ''
                  "
                  >{{ item.mobile }}</span
                >
                <span v-else>-</span>
              </td>
              <td class="text-left">
                <span
                  v-if="
                    item.phone && item.phone !== 'null' && item.phone !== ''
                  "
                  >{{ item.phone }}</span
                >
                <span v-else>-</span>
              </td>
              <td class="text-left">{{ item.category.name || "N/A" }}</td>
              <td class="text-center" v-if="item.status">
                <v-chip
                  small
                  class="ma-2"
                  dark
                  :color="getStatusColor(item.status)"
                >
                  {{ stringFormatting(item.status) }}
                </v-chip>
              </td>
              <td class="text-left">
                <v-btn
                  v-if="hasPermission('Suppliers.edit')"
                  color="#FFE0B2"
                  :to="'/supplier/edit/' + item.id"
                  fab
                  x-small
                  dark
                  style="box-shadow: none;"
                  class="ma-1"
                >
                  <v-icon small color="#FF9800">mdi-pencil</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  disabled
                  class="ma-1"
                  fab
                  x-small
                  style="box-shadow: none;"
                  ><v-icon small color="#FF9800">mdi-pencil</v-icon></v-btn
                >
                <v-btn
                  class="my-1"
                  v-if="hasPermission('Suppliers.delete')"
                  x-small
                  color="#FFCDD2"
                  @click="dropSupplierConfirm(item.id)"
                  fab
                  style="box-shadow: none;"
                >
                  <v-icon dark small color="#F44336">mdi-delete</v-icon>
                </v-btn>
                <v-btn
                  v-else
                  class="my-1"
                  disabled
                  fab
                  x-small
                  style="box-shadow: none;"
                >
                  <v-icon small color="#FF9800">mdi-delete</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
        </DataTableWithPagination>
      </v-card>
    </div>

    <ConfirmModal
      :text="'Do you want to drop this Supplier?'"
      :title="'Drop Supplier'"
      :color="'red'"
      :confirmOpen="confirmOpen"
      @cancelConfirm="cancelConfirm"
      @confirm="confirm"
    />
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="snackbarColor"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<style scoped>
.router-link {
  text-decoration: none;
}
.dark-row {
  background-color: #fafafa;
  color: rgb(0, 0, 0);
}
.light-row {
  background-color: #ffffff;
}
.custom-row {
  height: 60px;
  border: none;
}
</style>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

import PageTitleWithSearch from "@/components/shared/PageTitleWithSearch";
import ConfirmModal from "@/components/shared/ConfirmModal";
import Snackbars from "@/components/shared/Snackbars";
import DataTableWithPagination from "@/components/shared/DataTableWithPagination.vue";
import { checkError } from "@/config/errors.js";
import { SupplierService } from "@/services/supplier-service";
import Alert from "@/components/shared/Alert.vue";

export default {
  name: "SupplierGrid",
  components: {
    PageTitleWithSearch,
    ConfirmModal,
    Snackbars,
    DataTableWithPagination,
    Alert,
  },
  data: function() {
    return {
      defaultImage: require("@/assets/img/avatar.svg"),
      suppliers: [],
      search: "",
      loading: false,
      role: localStorage.getItem("role") || null,
      dropId: null,
      confirmOpen: false,
      snackbar: false,
      errors: null,
      successMsg: "",
      snackbarColor: "warning",
      page: 1,
      total: 0,
      totalSuppliers: 0,
      headers: [
        { text: "", value: "profile_image", align: "start" },
        { text: "Supplier Code", value: "supplier_code", align: "start" },
        { text: "Supplier Name", value: "name", align: "start" },
        { text: "Address", value: "address", align: "start" },
        { text: "Mobile", value: "mobile", align: "start" },
        { text: "Telephone", value: "phone", align: "start" },
        {
          text: "Supplier Type",
          value: "supplier_category_id",
          align: "start",
        },
        { text: "Status", value: "status", align: "center" },
        { text: "Action", value: "actions", align: "left" },
      ],
    };
  },
  watch: {
    search() {
      this.getSupplier();
    },
    page() {
      this.getSupplier();
    },
  },
  computed: {
    ...mapGetters({
      profile: "profile",
      hasPermission: "hasPermission",
    }),
  },
  mounted() {
    this.$store.dispatch("auth/getProfile");
    this.getSupplier();
  },

  methods: {
    async getSupplier() {
      this.loading = true;
      await SupplierService.getSupplierList(this.search, this.page)
        .then((response) => {
          this.loading = false;
          if (response.data && response.data.data) {
            this.suppliers = response.data.data;
            this.total = response.data.meta.last_page || 0;
            this.totalSuppliers = response.data.meta.total || 0;
          } else {
            this.suppliers = [];
          }
        })
        .catch((error) => {
          this.loading = false;
          this.suppliers = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },
    stringFormatting(str) {
      return str.replace(/_/g, " ");
    },
    getStatusColor(status) {
      let bgColor = "";

      switch (true) {
        case status === "ACTIVE":
          bgColor = "#A5D6A7";
          break;
        default:
          bgColor = "#EF9A9A";
          break;
      }

      return bgColor;
    },
    searchChange(value) {
      this.search = value;
    },
    dropSupplierConfirm(id) {
      this.dropId = id;
      this.confirmOpen = true;
      console.log("1 => Drop Supplier ", id);
    },
    cancelConfirm() {
      this.confirmOpen = false;
      console.log("Cancel supplier");
    },
    confirm() {
      this.confirmOpen = false;
      this.dropSupplier();
      console.log("2 => confirmed");
    },
    dropSupplier() {
      if (this.dropId) {
        this.loading = true;
        SupplierService.dropSupplier(this.dropId)
          .then((response) => {
            console.log("4 =>", response.data);
            this.successMsg = "Supplier successfully deleted";
            this.snackbarColor = "success";
            this.getSupplier();
            this.loading = false;
            this.snackbar = true;
          })
          .catch((error) => {
            this.loading = false;
            let data = error.response?.data?.error || "Unknown error";

            let errorOutput = checkError.errorFormatting(data);
            let errorsArray = [];
            if (Array.isArray(errorOutput)) {
              errorsArray = errorOutput.filter((e) => !!e && e.trim());
              if (errorsArray.length === 0) errorsArray = [data];
            } else if (errorOutput && errorOutput.trim()) {
              errorsArray = [errorOutput];
            } else {
              errorsArray = [data];
            }
            this.errors = errorsArray;
          });
      }
    },
    closeSnackbar() {
      this.snackbar = false;
    },

    onDismissed() {
      this.errors = null;
    },
  },
};
</script>
